/**
 * x402 Extensions
 *
 * Extensions provide additional functionality for the x402 protocol.
 */

export * from "./discovery";
